import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import the centralized config

const D01BarChartViz04 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    // Helper function to map filter keys to JSON keys
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey; // Default to the key if no mapping is found
    };

    // Retrieve the predefined sort order from FILTER_CONFIG
    const tenureConfig = FILTER_CONFIG.find(
      (item) => item.fieldName === "demographic_category_04"
    );
    const predefinedSortOrder = tenureConfig ? tenureConfig.sortOrder : [];

    // Apply filtering logic based on `filterCriteria`
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key); // Map filter key to JSON field
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected, include all items
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    // Filter data using the filter criteria
    const filteredData = jsonData.filter(filterData);

    // Aggregate data by tenure category (demographic_category_04)
    const demcat04Counts = filteredData.reduce((acc, item) => {
      const demcat04 = item.demographic_category_04;
      if (!acc[demcat04]) {
        acc[demcat04] = 0;
      }
      acc[demcat04]++;
      return acc;
    }, {});

    // Sort categories using predefined sort order from FILTER_CONFIG
    let demcat04Names = Object.keys(demcat04Counts);

    demcat04Names = demcat04Names.sort((a, b) => {
      const indexA = predefinedSortOrder.indexOf(a);
      const indexB = predefinedSortOrder.indexOf(b);

      if (indexA === -1 && indexB === -1) return a.localeCompare(b); // Alphabetical only if both are missing
      if (indexA === -1) return 1; // Push missing values to the end
      if (indexB === -1) return -1;
      return indexA - indexB;
    });

    const chartData = demcat04Names.map((demcat04) => demcat04Counts[demcat04]);

    // Update state
    setCategories(demcat04Names);
    setData(chartData);

    // Chart height calculation
    const barHeight = 25;
    const minBars = 10;
    const chartHeight = Math.max(
      barHeight * demcat04Names.length,
      barHeight * minBars
    );

    // Chart options
    const optionsViz04 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: chartHeight,
        width: "95%",
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
          distributed: false,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 20,
        style: {
          colors: ["#000"],
        },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 2.5,
          color: "#fff",
          opacity: 1,
        },
      },
      xaxis: {
        categories: demcat04Names, // Ensure sorting is applied to x-axis
      },
    };

    // Render the chart
    const viz04 = new ApexCharts(
      document.querySelector("#viz-04"),
      optionsViz04
    );
    viz04.render();

    // Cleanup chart on component unmount
    return () => {
      viz04.destroy();
    };
  }, [filterCriteria]);

  return (
    <div style={{ width: "100%", overflowY: "auto" }}>
      <div id="viz-04"></div>
    </div>
  );
};

export default D01BarChartViz04;
